// src/Login.js
import { Box, Button, Card, makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../contaxt/GlobalContext';
import apiEndPoints from '../../helpers/apiEndPoints';
import ApiClient from '../../helpers/ApiClient';
import bgImg from '../../images/Main-Page.jpg';

// define styles
const useStyles = makeStyles({
  root: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${bgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  card: {
    maxWidth: 550,
    padding: '70px 60px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'center',
    borderRadius: '0px !important',
    '& .MuiTypography-h5 ': {
      fontSize: 30,
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
    },
    '& .MuiTypography-body2': {
      fontSize: 18,
      marginBottom: '40px',
      lineHeight: '22px',
      color: '#444444',
    },
  },
  codeBox: {
    width: '100%',
    minHeight: '50px',
    borderBottom: '1.5px solid #ccc !important',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  codeInput: {
    width: '24px',
    height: '40px',
    textAlign: 'center',
    fontSize: '18px',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#000',
    '&:focus': {
      outline: 'none',
      border: 'none',
    },
  },
  dash: {
    display: 'inline-block',
    width: '24px',
    textAlign: 'center',
    fontSize: '20px',
    color: '#dfdfdf',
    userSelect: 'none',
  },
  loginBtn: {
    marginTop: '36px !important',
    color: '#fff !important',
    borderRadius: '0px !important',
    height: 46,
    textTransform: 'none !important',
    outline: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
    },
  },
  resend: {
    margin: '36px 0 10px 0 !important',
    cursor: 'pointer',
    fontSize: '16px',
    background: 'none',
    border: 'none',
    color: '#444444',
    fontWeight: '700',
  },
  errorMassage: {
    margin: '8px 0',
    textAlign: 'left',
    fontSize: 14,
    fontWeight: 600,
    color: '#cf1414',
  },
});

function VerifyMFA() {
  const classes = useStyles();
  const history = useHistory();
  const { email, password } = useContext(GlobalContext);
  const [code, setCode] = useState(Array(6).fill(''));
  const [disabled, setDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState('');
  const [otpError, setOtpError] = useState('');
  const slotsCount = 6;
  const [loading, setLoading] = useState(false);
  const isSixDigitCode =
    code.join('').length === 6 && /^\d{6}$/.test(code.join(''));
  const loginDisabled = !isSixDigitCode || loading;

  const handleLogin = () => {
    const enteredCode = code.join('');
    setLoading(true);
    const payload = {
      email,
      password,
      otp: enteredCode,
    };
    setError('');
    ApiClient.apiPost(apiEndPoints.login, payload)
      .then(response => {
        if (response.status === 200) {
          setError('');
          setCode(Array(slotsCount).fill(''));
          localStorage.setItem(
            'authorizationToken',
            JSON.stringify(response.data?.data?.access_token),
          );
          localStorage.setItem(
            'refresh_token',
            JSON.stringify(response?.data?.data?.refresh_token),
          );
          history.push('/manage-staff-list');
        } else {
          setError('Incorrect Verification code');
        }
      })
      .catch(err => {
        setError(err?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resendVerification = () => {
    const payload = {
      email,
      password,
      resendOtp: true,
    };
    setError('');
    setDisabled(true);
    setTimer(60);
    ApiClient.apiPost(apiEndPoints.login, payload)
      .then(response => {
        if (response.status === 200) {
          setCode(Array(slotsCount).fill(''));
          setTimer(60);
        }
        setOtpError('');
        setLoading(false);
      })
      .catch(err => {
        setOtpError(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    let interval;
    if (disabled && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [disabled, timer]);

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <Typography variant="h5" gutterBottom>
          Login with MFA
        </Typography>
        <Typography variant="body2" align="left" gutterBottom>
          Enter the 6 digit code we sent to your registered mobile number.
        </Typography>

        <div style={{ width: '100%' }}>
          <p
            align="left"
            style={{ fontSize: 16, marginBottom: '10px', color: '#838384' }}
          >
            MFA Code
          </p>
          <Box className={classes.codeBox}>
            {Array.from({ length: slotsCount }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={index}>
                <input
                  type="tel"
                  inputMode="numeric"
                  maxLength={1}
                  className={classes.codeInput}
                  value={code[index] || ''}
                  onChange={e => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    const newCode = [...code];
                    newCode[index] = value;
                    setCode(newCode);
                    if (value && index < slotsCount - 1) {
                      const nextInput = document.getElementById(
                        `code-${index + 1}`,
                      );
                      if (nextInput) nextInput.focus();
                    }
                  }}
                  id={`code-${index}`}
                />
                {index < slotsCount - 1 && (
                  <span className={classes.dash}>-</span>
                )}
              </React.Fragment>
            ))}
          </Box>
        </div>
        {error && <p className={classes.errorMassage}>{error}</p>}
        <Button
          fullWidth
          className={classes.loginBtn}
          style={{ backgroundColor: loginDisabled ? '#dfdfdf' : '#000' }}
          onClick={handleLogin}
          disabled={code.some(digit => !digit || digit.trim() === '')}
        >
          {loading ? 'Logging in…' : 'Login'}
        </Button>

        <button
          type="button"
          className={classes.resend}
          onClick={resendVerification}
          disabled={disabled}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {disabled ? `Resend Code (${timer}s)` : 'Resend Code'}
        </button>
        {otpError && <p className={classes.errorMassage}>{otpError}</p>}
      </Card>
    </Box>
  );
}

export default VerifyMFA;
